<template>
<v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on">
            <v-icon>mdi-menu</v-icon>Guesterix
        </v-btn>
    </template>
    <v-list>
        <v-list-item v-for="(item, index) in menuItems" :key="index" :to="item.path">
            <v-list-item-title>
                <v-icon left>{{ item.icon }}</v-icon>{{ item.title }} <b v-if="item.quantity > 0">({{ item.quantity }})</b>
            </v-list-item-title>
        </v-list-item>
    </v-list>
</v-menu>
</template>

<script>
import {
    mapState
} from "vuex";

export default {
    data() {
        return {
            drawer: false,
            group: null,
            appTitle: "Guesterix",
        };
    },
    computed: mapState({
        theme: (state) => state.global.theme,
        ownProfile: (state) => state.profiles.ownProfile,
        history: (state) => state.global.history,
        myEvents: (state) => state.events?.myEvents?.count,
        eventItems: (state) => state.events?.eventItems?.count,
        myInvitations(state) {
            return state.invitations?.invitations?.filter((e) => e.invitee.id === this.ownProfile.id).length
        },
        menuItems() {
            let menu = [{
                    title: "Home",
                    path: "/",
                    icon: "mdi-home",
                    quantity: 0,
                },
                {
                    title: "My events",
                    path: "/my_events",
                    icon: "mdi-calendar-multiple",
                    quantity: this.myEvents,
                },
                {
                    title: "My invitations",
                    path: "/my_invitations",
                    icon: "mdi-account-clock-outline",
                    quantity: this.myInvitations,
                },
                {
                    title: "My profile",
                    path: "/my_profile",
                    icon: "mdi-home-account",
                    quantity: 0,
                },
                {
                    title: "Logout",
                    path: "/logout",
                    icon: "mdi-logout",
                    quantity: 0,
                },
            ]

            if (this.ownProfile.is_superuser) {
                menu.push({
                    title: "Miscellaneous (for admin)",
                    path: "/miscellaneous",
                    icon: "mdi-check-all",
                    quantity: this.eventItems,
                })
            }
            return menu
        }
    }),
};
</script>
